import { render, staticRenderFns } from "./goods-posters.vue?vue&type=template&id=72c78060&scoped=true&"
import script from "./goods-posters.vue?vue&type=script&lang=js&"
export * from "./goods-posters.vue?vue&type=script&lang=js&"
import style0 from "./goods-posters.vue?vue&type=style&index=0&id=72c78060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c78060",
  null
  
)

export default component.exports